import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {
  AbstractControl,
  AsyncValidatorFn,
  FormControl, FormGroup,
  FormRecord,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {Country, MatSelectCountryModule} from '@angular-material-extensions/select-country';
import {CountryService} from '../../../../../services/country.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {UserService} from '../../../../../services/user-services/user.service';
import {LocalSettingsService} from '../../../../../services/local-settings.service';
import {finalize, first, map} from 'rxjs/operators';
import {AuthenticationService} from '../../../../../services/authentication.service';
import {Router} from '@angular/router';
import {ProcessSharedService} from '../../../../../services/process-shared.service';
import {CountryISO, NgxIntlTelInputModule} from '@justin-s/ngx-intl-tel-input';
import {OpenCookieWidgetDirective} from '../../../../../directives/openCookieWidget.directive';
import {MatOptionModule} from '@angular/material/core';
import {MatSelectModule} from '@angular/material/select';
import {BirthdateDividedComponent} from '../../../ux/birthdate-divided/birthdate-divided.component';
import {CheckFormErrorDirective} from '../../../../../directives/checkFormError.directive';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {NgClass, NgFor, NgIf} from '@angular/common';
import {emailDomainValidator} from "../../../../../validators/email-domain-validator.validator";
import {MatCheckbox} from "@angular/material/checkbox";
import {MatRadioButton, MatRadioGroup} from "@angular/material/radio";
import {
  AccommodationCityInputComponent
} from "../../../../../pages/processes/accommodation/components/accommodation-city-input/accommodation-city-input.component";

@Component({
  selector: 'app-modale-register',
  templateUrl: './modale-register.component.html',
  styleUrls: ['./modale-register.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    NgxIntlTelInputModule,
    NgClass,
    CheckFormErrorDirective,
    BirthdateDividedComponent,
    MatSelectCountryModule,
    MatSelectModule,
    NgFor,
    MatOptionModule,
    OpenCookieWidgetDirective,
    TranslateModule,
    MatCheckbox,
    MatRadioButton,
    MatRadioGroup,
    AccommodationCityInputComponent,
  ],
})
export class ModaleRegisterComponent implements OnInit, AfterViewInit, OnDestroy {

  @Output() private isModalClosed: EventEmitter<any> = new EventEmitter<any>();
  @Output() private isBtnClicked: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('registerModal') private registerModal;
  @Input() school;
  @Input() slug = 'livinfrance';
  @Input() oAuthUser?;
  @Input() returnUrl: string;

  private sub$;
  public page = 1;
  public maxPage = 3;

  // page 1 user 1 form
  public accountForm: FormRecord = new FormRecord<FormControl<string | null>>({});
  public isAccountFormSubmit = false;
  public CountryISO = CountryISO;
  public errors = {'firstname': null, 'lastname': null};

  // page 2 user 2 form
  public userForm: FormRecord = new FormRecord<FormControl<string | null>>({});
  public isUserFormSubmit = false;
  public isBirthdayCorrect = true;
  public predefinedCountries: Country[] = [];

  // page 3 school form
  public schoolForm: UntypedFormGroup;
  public isSchoolFormSubmit = false;
  public formations: any[] = [];

  // page 4 - students infos
  public showInfosForm=false;
  public hasSchool: boolean = false;
  public hasSubmitInfos=false;
  public infoForm: FormGroup = new FormGroup({
    city_id: new FormControl<number | null>(null),
    city_name: new FormControl<string | null>(null),
    school_id: new FormControl<number | null>(null),
    school_name: new FormControl<string | null>(null),
    stayDuration: new FormControl(null),
  })


  // create account form
  public credForm: UntypedFormGroup;
  public isCredFormSubmit = false;

  // Give info about registration status
  public registerStatus: string = null;
  registerError = false;
  public displayUnit: boolean = false;
  isFocused: boolean;

  constructor(
    private modalService: NgbModal,
    private fb: UntypedFormBuilder,
    private countryService: CountryService,
    public translate: TranslateService,
    private userService: UserService,
    private _localSettings: LocalSettingsService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private processSharedService: ProcessSharedService,
  ) {
    this.accountForm = this.fb.group({
      lastname: [this.oAuthUser ? this.oAuthUser.lastName : '', Validators.required],
      firstname: [this.oAuthUser ? this.oAuthUser.firstName : '', Validators.required],
      phone: ['', Validators.required],
    });
    this.predefinedCountries = this.countryService.getCountries();
    this.translate.get('COUNTRIES').subscribe(() => {
      this.predefinedCountries.forEach(element => {
        const code = element.alpha2Code;
        element.name = this.translate.instant('COUNTRIES.' + code);
      });
    });
    this.userForm = this.fb.group({
      birthdate: [null, Validators.required],
      nationality: [null, Validators.required],
      gender: [null, Validators.required],
    });
  }

  ngOnInit(): void {
    if (this.school && this.school.slug !== 'harvard' && this.school.slug !== 'livinfrance') {
      this.maxPage += 1;
      // Stay duration en page 2 uniquement si pas LF
      this.userForm.addControl('stayDuration', new FormControl(null, Validators.required));
    }


    this.sub$ = this.modalService.activeInstances.subscribe((list) => {
      if (list.length === 0) {
        this.isModalClosed.emit(null);
      }
    });
    this.processSharedService.getFormations().subscribe(async (data: any) => {
      this.formations = data.data;
      this.formations.sort((a, b) => a.name.localeCompare(b.name));
    });
  }

  ngAfterViewInit(): void {
    this.modalService.open(this.registerModal, {size: 'md', centered: true});
  }

  ngOnDestroy(): void {
    this.modalService.dismissAll();
    this.sub$.unsubscribe();
  }


  /************************************ utilities, navigation ****************************************/
  private nextPage(): void {
    if (this.page < this.maxPage) {
      this.page++;
    }
  }

  public prevPage(): void {
    if (this.page > 0) {
      this.page--;
    }
  }

  public goToLogin(): void {
    this.isModalClosed.emit('login');
  }

  /************************************ FORM CONTROL SETTER ****************************************/
  // @TODO : faire un validateur perso ? Globaliser la fonction ?
  public setBirthdate(event): void {
    if (event.yearControl && event.monthControl && event.dayControl) {
      const dateCheck = new Date(event.yearControl, event.monthControl - 1, event.dayControl);
      if (dateCheck.getFullYear() != event.yearControl || (dateCheck.getMonth() + 1) != event.monthControl || dateCheck.getDate() != event.dayControl) {
        this.isBirthdayCorrect = false;
      } else {
        this.isBirthdayCorrect = true;
        this.userForm.controls.birthdate.setValue(dateCheck.getFullYear() + '-' + (dateCheck.getMonth() + 1) + '-' + dateCheck.getDate());
      }
    }
  }

  public onCountrySelected(event): void {
    this.userForm.patchValue({nationality: event});
  }

  public checkLatin(field, e) {
    const regex = new RegExp('^[A-zÀ-ÿ0-9- \']+$');
    if (regex.test(e.target.value)) {
      this.errors[field] = null;
      this.accountForm.controls[field].setErrors(null);
    } else {
      this.errors[field] = this.translate.instant('COMMON.ONLY_LATIN_ERROR');
      this.accountForm.controls[field].setErrors({'incorrect': true});
    }
  }

  private createCredForm() {
    if (!this.credForm) {
      this.credForm = this.fb.group({
        email: [this.oAuthUser ? this.oAuthUser.email : null, [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'), emailDomainValidator()], [uniqueEmailValidator(this.userService)]],
        password: [null, [Validators.required, Validators.minLength(6)]],
        consent: [false, [Validators.required, Validators.requiredTrue]],
      });
    }
  }

  /************************************ FORM SUBMIT ****************************************/

  public submitForm(): void {
    if (this.page === this.maxPage) {
      this.isCredFormSubmit = true;
      if (this.credForm && this.credForm.valid) {
        this.registerUser();
      }
    } else {
      switch (this.page) {
        case 1 : {
          this.submitAccountForm();
          break;
        }
        case 2 : {
          this.submitUserForm();
          break;
        }
        case 3: {
          this.submitSchoolForm();
          break;
        }
      }
    }
  }

  private submitAccountForm(): void {
    this.isAccountFormSubmit = true;
    if (this.accountForm.valid) {
      this.nextPage();
    }
  }

  private submitUserForm(): void {
    this.isUserFormSubmit = true;
    if (this.isBirthdayCorrect && this.userForm.valid) {
      this.nextPage();
      if (this.page !== this.maxPage) {
        this.createSchoolForm();
      } else {
        this.createCredForm();
      }
    }
  }

  private createSchoolForm() {
    if (!this.schoolForm) {
      this.schoolForm = this.fb.group({
        situation: ['', Validators.required],
        formation_id: ['', Validators.required],
      });
      if (this.school.faculties && this.school.faculties.length > 0) {
        this.schoolForm.addControl('faculty_id', new FormControl<number | null>(null, [Validators.required]));
      }
      if (this.school.rgpdOutPut) {
        this.schoolForm.addControl('shareData', new FormControl<boolean>(false, [Validators.requiredTrue]));
      }
    }
  }

  private submitSchoolForm(): void {
    this.isSchoolFormSubmit = true;
    if (this.schoolForm.valid) {
      this.nextPage();
      this.createCredForm();
    }
  }

  /************************************************************************************************/

  /************************************************************************************************/

  public changeDisplayUnit(event: FocusEvent): void {
    this.displayUnit = !this.displayUnit;
     this.isFocused = event.type === 'focusin'
  }

  /**
   * Enregistre l'utilisateur en base et le redirige.
   * @private
   */
  private registerUser(): void {
    this.registerError = false;
    this.registerStatus = 'create';
    const language = this._localSettings.getLanguage();
    const referer = this._localSettings.getReferer();
    if (this.accountForm.value.phone.internationalNumber) {
      this.accountForm.value.phone = this.accountForm.value.phone.internationalNumber;
    }
    this.userService.register({
      lastname: this.accountForm.value.lastname,
      firstname: this.accountForm.value.firstname,
      email: this.credForm.value.email,
      phone: this.accountForm.value.phone,
      password: this.credForm.value.password,
      gender: this.userForm.value.gender,
      nationality: this.userForm.value.nationality.alpha2Code,
      birthdate: this.userForm.value.birthdate,
      birthCountry: this.userForm.value.nationality.name,
      textLanguage: language == '' ? 'en' : language,
      accept: true,
      referer: referer,
      faculty_id: this.schoolForm ? this.schoolForm.value.faculty_id : null,
      formation_id: this.schoolForm ? this.schoolForm.value.formation_id : null,
      situation: this.schoolForm ? this.schoolForm.value.situation : null,
      schoolSlug: this.school.slug,
      school_id: this.school.id,
      city_id: this.school.city_id
    }).pipe(first())
      .subscribe((data: any) => {
        if (data.status === 'success') {
          this.login();
        } else {
          if (data.error && data.error.email) {
            this.credForm.controls.email.setErrors({'taken': true});
          }
          this.registerStatus = null;
          this.registerError = true;
        }
      });
  }

  private login() {
    this.authenticationService.login(this.credForm.controls.email.value, this.credForm.controls.password.value, 'livinfrance')
      .pipe(first())
      .subscribe(data => {
        if (data.status !== 'error') {
          if (this.school.slug !== 'livinfrance') {
            this.redirectToDashboard();
          } else {
            this.showInfosForm = true;
          }
        } else {
          this.registerStatus = null;
          this.registerError = true;
        }
      });
    this.registerStatus = 'login';
  }

  private redirectToDashboard() {
    this.isBtnClicked.emit(true);
    this.registerStatus = 'redirect';
    this.modalService.dismissAll();
    if (this.router.url !== '/' + this.returnUrl) {
      this.router.navigate([this.returnUrl]);
    } else {
      window.location.hash = 'reload';
      window.location.reload();
    }
  }

  /* @memo : Pas de .subscribe() sur le update pour pas call 2 fois la fonction (il y a un .sub intégré dans l'update)
  Pas mettre d'unsub non plus pour que le call se fasse quand même du coup..
   */
  public finishLGeneralRegister():void {
    this.hasSubmitInfos = true;
      this.registerStatus = 'updating';
      this.userService.update({
        city_id:this.infoForm.controls.city_id.value,
        city:this.infoForm.controls.city_name.value,
        interestId: this.infoForm.controls.school_id.value,
        interestName: this.infoForm.controls.school_name.value,
        stayDuration:this.infoForm.controls.stayDuration.value,
      });
      this.redirectToDashboard();
  }


  getCity(e: any) {
    this.infoForm.controls.city_id.patchValue(null);
    this.infoForm.controls.city_name.patchValue(null);
    if (e) {
      if (e.id) {
        this.infoForm.controls.city_id.patchValue(e.id);
      }
      if (e.name) {
        this.infoForm.controls.city_name.patchValue(e.name);
      }
    }
  }

  getSchool(e:any) {
    this.infoForm.controls.school_id.patchValue(null);
    this.infoForm.controls.school_name.patchValue(null);
    if (e) {
      if (e.id) {
        this.infoForm.controls.school_id.patchValue(e.id);
      }
      if (e.name) {
        this.infoForm.controls.school_name.patchValue(e.name);
      }
    }
  }

}


/**
 * Custom Validator.
 * Permet de vérifier avant envoie du form si le mail choisi est unique ou pas.
 * @param userService
 */
export function uniqueEmailValidator(userService: UserService): AsyncValidatorFn {
  return (c: AbstractControl): { [key: string]: boolean } | any => {
    return userService.checkExist(c.value)
      .pipe(
        map((data: boolean) => {
          if (data == true) {
            return {taken: true};
          }
        })
      );
  };
}
